<template>
  <div>
    <!-- 天气类型 -->
    <AttrSelect
      v-if="shape.sourceItem?.weatherValueRange"
      label="天气类型"
      tooltip="部分小内存设备可能需要用到精简版，请视情况而定"
      :value="shape.attrs.sourceWeatherType ?? 'whole'"
      :disabled="disabled"
      :options="weatherTypeOptions"
      @change="(v:any)=>shape.setAttrs({'sourceWeatherType':v})"
    />
    <!-- 填充类型 -->
    <AttrSelect
      label="填充类型"
      :value="shape.attrs.fillType"
      :disabled="disabled"
      :options="typeOptions"
      @change="changeFillType"
    />

    <!-- 数据源下颗粒度 -->
    <AttrSelect
      v-if="
        shape.attrs.fillType == '普通填充' &&
        shape.sourceItem?.progressAccuracy?.length
      "
      label="颗粒度"
      :value="shape.attrs.sourceProgressAccuracy ?? 10"
      :disabled="disabled"
      :options="progressAccuracyOptions"
      @change="setProgressAccuracy"
    />
  </div>
</template>

<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { Attributes } from '@/services/shape/attributes';
import { useEditorStore } from '@/store/use-editor-store';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { canUseDataSourceByShape } from '@/utils/can-use.utils';
import { Modal } from 'ant-design-vue';
import { PropType, computed } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const typeOptions = ['普通填充', '数字填充'].map((item) => {
  return {
    label: item,
    value: item
  };
});

const watchfaceStore = useWatchfaceStore();
const editorStore = useEditorStore();
const progressAccuracyOptions = computed(() => {
  const isM66 = watchfaceStore.deviceType == 'M66';
  return props.shape.sourceItem?.progressAccuracy
    ?.filter((item) => {
      if (isM66 && item != 10) return false;
      return true;
    })
    .map((item) => {
      // M66设备只允许10%进度

      return {
        label: item == 0 ? '自定义' : item + '%',
        value: item
      };
    });
});

const weatherTypeOptions = computed(() => {
  return [
    { value: 'whole', label: '完整版' },
    { value: 'simple', label: '精简版' }
  ];
});

const changeFillType = (fillType: Attributes['fillType']) => {
  const valid = validSourceData(fillType);
  // 普通填充不允许设置align，所以需要将align重置成left
  const data: Partial<Attributes> = { fillType, align: 'left' };
  if (!valid) {
    return;
    // data['source'] = '';
    // data['sourceFormat'] = undefined;
  }
  props.shape.setAttrs(data);
};

const validSourceData = (fillType: Attributes['fillType']) => {
  const isAllowed = canUseDataSourceByShape({
    sourceKey: props.shape.attrs.source ?? '',
    deviceType: watchfaceStore.deviceType,
    shapeType:
      fillType == '数字填充' ? 'image-array-digit' : 'image-array-normal',
    themeType: editorStore.theme?.type ?? 'normal'
  });

  if (!isAllowed) {
    Modal.warning({
      title: '提示',
      content: `当前数据不支持切换填充类型`,
      okText: '知道了'
    });
    return false;
  }
  return true;
};
const setProgressAccuracy = (v: number) => {
  const shape = props.shape;
  const data: Record<string, number | number[][]> = {
    sourceProgressAccuracy: v
  };
  // 代表自定义
  if (v == 0) {
    data['sourceProgressCustom'] = [
      [1, 25],
      [26, 50],
      [51, 80],
      [81, 100]
    ];
  }
  shape.setAttrs(data);
};
</script>
<style scoped></style>
